'use client';

import { __assign, __awaiter, __generator } from '../_virtual/_tslib.js';
import React__default, { useRef, useState, useEffect } from 'react';
import Col from '../LayoutSystem/Col.js';
import Row from '../LayoutSystem/Row.js';
import { Container, Wrapper, TopContainer, Left, NextImageContainer, Right, CompanyName, Salary, Location, BottomContainer, Badge, JobInvitationBlock, AppliedText, SaveJobWrapper, AISummary, Separator, StyledTooltip, MatchingText, NewBadgeWrapper, CustomH2 } from './JobPostCard.css.js';
import BadgeTag from '../BadgeTag/index.js';
import { REQUIRED_COVER_LETTER, DEFAULT_IMAGE, SERVICE_CODE_URGENT_JOB, SERVICE_CODE_TOP_MANAGEMENT_JOB, SERVICE_CODE_HEADHUNT_JOB, SERVICE_CODE_HEADHUNT_JOB_MOBILE, badgeSettings } from './constant.js';
import { ELanguage } from '../Utils/constants.js';
import translations from './translations.js';
import { formatedJob, checkIsNew, convertISOToMillisecond, buildCompanyUrl } from './utils.js';
import { unsaveJob, saveJob } from './services.js';
import { showToast } from '../Toast/index.js';
import HeartFillIcon from '../PreviewJob/Images/HeartFillIcon.js';
import PreviewJob from '../PreviewJob/index.js';
import { generateJobUrl } from '../Utils/helpers.js';
import Misc from '../icons/MiscGroupIcons/index.js';
import { colors } from '../Colors/index.js';
import ApplyJobs from '../ApplyJobs/index.js';
import useHog from '../PostHog/hooks/useHog/index.js';
import '../UploadResumeModal/type.js';
import '../Images/AddIcon/index.js';
import '../Images/AddOutlinedIcon/index.js';
import '../Images/Trash/index.js';
import '../Images/Pencil/index.js';
import '../Images/ArrowRoundedLeft/index.js';
import '../Images/ArrowRoundedRight/index.js';
import '../Images/AwardsIcon/index.js';
import '../Images/BonusIcon/index.js';
import '../Images/CanteenIcon/index.js';
import '../Images/CheckTagIcon/index.js';
import '../Images/CommercialIcon/index.js';
import '../Images/CompanySizeIcon/index.js';
import '../Images/ContactIcon/index.js';
import '../Images/CopyIcon/index.js';
import '../Images/DefaultAvatar/index.js';
import '../Images/DangerIcon/index.js';
import '../Images/ExternalLinkIcon/index.js';
import '../Images/FacebookIcon/index.js';
import '../Images/ForwardIcon/index.js';
import '../Images/HealthcarePlanIcon/index.js';
import '../Images/HeartIcon/index.js';
import '../Images/HeartOutlineIcon/index.js';
import '../Images/HideIcon/index.js';
import '../Images/KindergartenIcon/index.js';
import '../Images/LaptopIcon/index.js';
import '../Images/LibraryIcon/index.js';
import '../Images/LinkIcon/index.js';
import '../Images/LinkedInIcon/index.js';
import '../Images/LoadingCircleIcon/index.js';
import '../Images/MarkerIcon/index.js';
import '../Images/MobileIcon/index.js';
import '../Images/PaidLeaveIcon/index.js';
import '../Images/SearchIcon/index.js';
import '../Images/ShareIcon/index.js';
import '../Images/ReportIcon/index.js';
import '../Images/StatsIcon/index.js';
import '../Images/TeamActivitiesIcon/index.js';
import '../Images/ThreeDotIcon/index.js';
import '../Images/TrainingIcon/index.js';
import '../Images/TransportationIcon/index.js';
import '../Images/TrashIcon/index.js';
import '../Images/TravelOpportunitiesIcon/index.js';
import '../Images/VerticalMoreIcon/index.js';
import '../Images/VoucherIcon/index.js';
import '../Images/WowCVIcon/index.js';
import WorkingLocationIcon from '../Images/WorkingLocationIcon/index.js';
import '../Images/ZaloIcon/index.js';
import '../Images/FacebookLogoIcon/index.js';
import '../Images/GoogleLogoIcon/index.js';
import '../Images/DragReorderIcon/index.js';
import '../Images/CheckIcon/index.js';
import '../Images/CircleChecked/index.js';
import SalaryIcon from '../Images/SalaryIcon/index.js';
import '../Images/BriefcaseIcon/index.js';
import '../Images/GraduationCapIcon/index.js';
import '../Images/EnvelopeIcon/index.js';
import '../Images/AddFilledIcon/index.js';
import '../Images/HomeIcon/index.js';
import '../Images/PhoneIcon/index.js';
import '../Images/AttachIcon/index.js';
import '../Images/FilterIcon/index.js';
import '../icons/WarnIcon.js';
import '../icons/AccountSettingsIcon.js';
import '../icons/DashboardIcon.js';
import '../icons/JobAlertsIcon.js';
import '../icons/MyCompaniesIcon.js';
import '../icons/MyJobsIcon.js';
import '../icons/MyProfileIcon.js';
import '../icons/ProfileSettingsIcon.js';
import '../icons/LanguageIcon.js';
import '../icons/BenefitGroupIcons/ActivityIcon.js';
import '../icons/BenefitGroupIcons/AwardsIcon.js';
import '../icons/BenefitGroupIcons/BonusIcon.js';
import '../icons/BenefitGroupIcons/CanteenIcon.js';
import '../icons/BenefitGroupIcons/HealthcareIcon.js';
import '../icons/BenefitGroupIcons/KindergartenIcon.js';
import '../icons/BenefitGroupIcons/LaptopIcon.js';
import '../icons/BenefitGroupIcons/LibraryIcon.js';
import '../icons/BenefitGroupIcons/MoreIcon.js';
import '../icons/BenefitGroupIcons/PaidLeaveIcon.js';
import '../icons/BenefitGroupIcons/PhoneIcon.js';
import '../icons/BenefitGroupIcons/TrainingIcon.js';
import '../icons/BenefitGroupIcons/TransportationIcon.js';
import '../icons/BenefitGroupIcons/TravelIcon.js';
import '../icons/BenefitGroupIcons/VoucherIcon.js';
import '../icons/BenefitGroupIcons/Physics.js';
import '../icons/BenefitGroupIcons/WorkingHourIcon.js';
import '../icons/BenefitGroupIcons/WorkingDayIcon.js';
import '../icons/BenefitGroupIcons/WorkingTypeIcon.js';
import '../icons/AccountCenterGroupIcons/ChartVertical.js';
import '../icons/AccountCenterGroupIcons/Language.js';
import '../icons/AccountCenterGroupIcons/EmptyHotCategory.js';
import '../icons/AccountCenterGroupIcons/Lawyer.js';
import '../icons/InfoOverviewGroupIcons/CompanySize.js';
import '../icons/InfoOverviewGroupIcons/Location.js';
import '../icons/InfoOverviewGroupIcons/Education.js';
import '../icons/InfoOverviewGroupIcons/PhoneNumber.js';
import '../icons/InfoOverviewGroupIcons/CalendarIOS16Glyph.js';
import '../icons/InfoOverviewGroupIcons/Admin.js';
import '../icons/InfoOverviewGroupIcons/HeadHunter.js';
import '../icons/InfoOverviewGroupIcons/Address.js';
import '../icons/InfoOverviewGroupIcons/Salary.js';
import '../icons/InfoOverviewGroupIcons/Gender.js';
import '../icons/InfoOverviewGroupIcons/Translator.js';
import '../icons/InfoOverviewGroupIcons/Birthday.js';
import '../icons/InfoOverviewGroupIcons/LocationIOS16Glyph.js';
import '../icons/InfoOverviewGroupIcons/CreditIcon.js';
import '../icons/SocialMediaGroupIcons/Facebook.js';
import '../icons/SocialMediaGroupIcons/Linkedin.js';
import '../icons/SocialMediaGroupIcons/Twitter.js';
import '../icons/SocialMediaGroupIcons/Zalo.js';
import '../icons/SocialMediaGroupIcons/FacebooksColorFull.js';
import '../icons/SocialMediaGroupIcons/LinkedinColorFull.js';
import '../icons/SocialMediaGroupIcons/TwitterColorFull.js';
import '../icons/SocialMediaGroupIcons/ZaloColorFull.js';
import '../icons/SocialMediaGroupIcons/Share.js';
import '../icons/NavigationGroupIcons/Vertical.js';
import '../icons/NavigationGroupIcons/More.js';
import '../icons/NavigationGroupIcons/Close.js';
import '../icons/NavigationGroupIcons/Expand.js';
import '../icons/NavigationGroupIcons/Collapse.js';
import '../icons/NavigationGroupIcons/Next.js';
import '../icons/NavigationGroupIcons/Back.js';
import '../icons/NavigationGroupIcons/ExternalLink.js';
import '../icons/NavigationGroupIcons/RightArrow.js';
import '../icons/AlertGroupIcons/SuccessIcon.js';
import '../icons/AlertGroupIcons/CareerPath.js';
import '../icons/AlertGroupIcons/Hot.js';
import '../icons/AlertGroupIcons/Urgent.js';
import '../icons/FormActionGroupIcons/Exchange.js';
import '../icons/FormActionGroupIcons/AddTag.js';
import '../icons/RewardsTypeGroupIcons/Hospital.js';
import MailAddIcon from '../Images/MailAddIcon/index.js';
import DoubleTickIcon from '../Images/DoubleTickIcon/index.js';
import '../Images/BellIcon/index.js';
import '../Images/AiIcon/index.js';
import '../Images/MiniAiIcon/index.js';
import '../icons/OrderManagementIcon.js';
import TwinkleLinearGradientIcon from '../Images/TwinkleLinearGradientIcon/index.js';
import SaveLoadingIcon from '../JobCard/Components/Images/SaveLoadingIcon.js';
import 'react-dom';
import '../hooks/useMakeSearchable/types.js';
import '../services/resumes/types.js';
import useElementOnScreen from '../Utils/hooks/UseElementOnScreen/index.js';
import RibbonTag from './RibbonTag.js';

var JobPostCard = function (props) {
    var _a;
    var data = props.data, langCode = props.langCode, robot = props.robot, api = props.api, custom = props.custom, _b = props.utm, utm = _b === void 0 ? '' : _b, _c = props.companyUTM, companyUTM = _c === void 0 ? '' : _c, _d = props.classSelector, classSelector = _d === void 0 ? '' : _d, userInfo = props.userInfo, _e = props.nextImage, nextImage = _e === void 0 ? null : _e, _f = props.isForceJobLinkVI, isForceJobLinkVI = _f === void 0 ? false : _f, headingTagTitleJob = props.headingTagTitleJob, _g = props.layout, layout = _g === void 0 ? 'primary' : _g, onSave = props.onSave, trackingSetting = props.trackingSetting, _h = props.enableVisualized, enableVisualized = _h === void 0 ? false : _h, _j = props.enableAISummary, enableAISummary = _j === void 0 ? false : _j, _k = props.isJobSearchPage, isJobSearchPage = _k === void 0 ? false : _k, _l = props.sorting, sorting = _l === void 0 ? 'default' : _l;
    var previewJob = __assign({ enable: true }, props.previewJob);
    var jobCardRef = useRef(null);
    var jobCardHeight = useRef(0);
    var isAleadyTrackingViewJob = useRef(false);
    var _m = (custom || {}).forceNormalJob, forceNormalJob = _m === void 0 ? false : _m;
    var _o = useState(false), isShowApplyPopup = _o[0], setShowApplyPopup = _o[1];
    var _p = useState(!!(data === null || data === void 0 ? void 0 : data.isSaved)), isSaved = _p[0], setSaved = _p[1];
    var _q = useState(false), isSaveLoading = _q[0], setSaveLoading = _q[1];
    var formatedJobData = formatedJob(data);
    var tracking = useHog().tracking;
    var isElementOnScreen = useElementOnScreen({
        target: jobCardRef,
        options: {
            rootMargin: '0px 0px 0px 0px'
        }
    })[0];
    var isNewJob = checkIsNew(data);
    var showLogo = !!(data.companyLogo && data.isShowLogo && !data.isAnonymous);
    var location = langCode === ELanguage.EN
        ? (formatedJobData.locations || []).join(', ')
        : (formatedJobData.locationVIs || []).join(', ');
    var isLogin = !!(api === null || api === void 0 ? void 0 : api.accessToken);
    var isBoldAndRed = !!data.isBoldAndRedJob || !!data.visibilityDisplay;
    var shouldMakeJobPriority = data.priorityOrder !== undefined && convertISOToMillisecond(data.priorityOrder) > 0;
    var companyUrl = buildCompanyUrl(data.companyId || 0, data.companyName || '', langCode);
    var serviceCode = formatedJobData.serviceCode, isPremium = formatedJobData.isPremium, isUrgentJob = formatedJobData.isUrgentJob, isTopManagementJob = formatedJobData.isTopManagementJob, isHeadhuntJob = formatedJobData.isHeadhuntJob;
    var t = function (key) {
        var _a;
        if (langCode === ELanguage.EN) {
            return key;
        }
        else {
            return (_a = translations[key]) !== null && _a !== void 0 ? _a : key;
        }
    };
    var isLayoutPrimary = layout === 'primary';
    var isLayoutSecondary = layout === 'secondary';
    var handleUnsavedJob = function () { return __awaiter(void 0, void 0, void 0, function () {
        var success;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!isLogin) {
                        /* redirectToLogin() */
                        return [2 /*return*/];
                    }
                    setSaveLoading(true);
                    return [4 /*yield*/, unsaveJob({
                            jobId: data.jobId,
                            accessToken: (api === null || api === void 0 ? void 0 : api.accessToken) || '',
                            language: langCode,
                            baseUrl: (api === null || api === void 0 ? void 0 : api.baseUrl) || ''
                        })];
                case 1:
                    success = (_a.sent()).data;
                    setSaveLoading(false);
                    if (success) {
                        setSaved(false);
                        onSave && onSave(false);
                        showToast(t('Success'), t('Just removed 1 saved job'));
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleSaveJob = function (isFromPreviewJob) {
        if (isFromPreviewJob === void 0) { isFromPreviewJob = false; }
        return __awaiter(void 0, void 0, void 0, function () {
            var success;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!isLogin) {
                            /* redirectToLogin() */
                            return [2 /*return*/];
                        }
                        setSaveLoading(true);
                        return [4 /*yield*/, saveJob({
                                jobId: data.jobId,
                                accessToken: (api === null || api === void 0 ? void 0 : api.accessToken) || '',
                                language: langCode,
                                baseUrl: (api === null || api === void 0 ? void 0 : api.baseUrl) || ''
                            })];
                    case 1:
                        success = (_b.sent()).data;
                        setSaveLoading(false);
                        if (success) {
                            tracking({
                                eventName: 'js_job_management:save_job_click',
                                properties: {
                                    jobId: (_a = data === null || data === void 0 ? void 0 : data.jobId) !== null && _a !== void 0 ? _a : -1,
                                    pageZone: isFromPreviewJob ? 'preview' : 'job_card_full'
                                }
                            });
                            setSaved(true);
                            onSave && onSave(true);
                            showToast(t('Success'), React__default.createElement("div", null,
                                t('You have saved job, view'),
                                ' ',
                                React__default.createElement("a", { href: t('/my-career-center/my-jobs?section=saved') }, t('My jobs'))));
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    var handleLogin = function () {
        if (isLogin) {
            return;
        }
        var loginEvent = new CustomEvent('LOGIN_POPUP', {
            detail: {
                langCode: langCode === ELanguage.VI ? 'vi' : 'en',
                isNeedReload: false
            }
        });
        window.dispatchEvent(loginEvent);
    };
    useEffect(function () {
        setSaved(data.isSaved || false);
    }, [data]);
    useEffect(function () {
        var _a;
        jobCardHeight.current = ((_a = jobCardRef.current) === null || _a === void 0 ? void 0 : _a.offsetHeight) || 0;
    }, []);
    useEffect(function () {
        var _a, _b, _c, _d;
        if ((trackingSetting === null || trackingSetting === void 0 ? void 0 : trackingSetting.isTrackingOnSeen) && isElementOnScreen && !isAleadyTrackingViewJob.current) {
            var properties = {
                jobTitle: data.jobTitle,
                prettySalary: (data === null || data === void 0 ? void 0 : data.prettySalary) === 'Thương lượng' ? 'Negotiable' : (data === null || data === void 0 ? void 0 : data.prettySalary) || '',
                createdOn: (data === null || data === void 0 ? void 0 : data.createdOn) || '',
                workingLocationCityId: ((data === null || data === void 0 ? void 0 : data.workingLocations) || []).map(function (item) { return item.cityId; }),
                expiredDate: data.expiredOn,
                jobIndustryId: ((data === null || data === void 0 ? void 0 : data.industriesV3) || []).map(function (item) { return item.industryIdV3; }),
                jobFunctionId: (_a = data === null || data === void 0 ? void 0 : data.jobFunctionsV3) === null || _a === void 0 ? void 0 : _a.jobFunctionV3Id,
                jobGroupFunctionId: (_b = data === null || data === void 0 ? void 0 : data.groupJobFunctionsV3) === null || _b === void 0 ? void 0 : _b.groupJobFunctionV3Id,
                jobLevelId: Number(data === null || data === void 0 ? void 0 : data.jobLevelId),
                typeWorkingId: data === null || data === void 0 ? void 0 : data.typeWorkingId,
                skillTag: ((data === null || data === void 0 ? void 0 : data.skills) || []).map(function (item) { return item.skillName; }).join(', '),
                isCoverLetterRequired: (data === null || data === void 0 ? void 0 : data.requiredCoverLetter)
                    ? (data === null || data === void 0 ? void 0 : data.requiredCoverLetter) === REQUIRED_COVER_LETTER
                    : false,
                jobId: data.jobId,
                isAnonymous: data.isAnonymous,
                isPremium: isPremium,
                isHeadhunt: isHeadhuntJob,
                isUrgent: isUrgentJob,
                isUrgentM: data === null || data === void 0 ? void 0 : data.isUrgentJobM,
                isTopmanagement: isTopManagementJob,
                isAdr: data === null || data === void 0 ? void 0 : data.isAdrLiteJob,
                isBoldandred: data.isBoldAndRedJob,
                isBoldandredM: data === null || data === void 0 ? void 0 : data.isBoldAndRedJobM,
                isPriority: shouldMakeJobPriority,
                isPriorityM: shouldMakeJobPriority && (data === null || data === void 0 ? void 0 : data.isTopPriorityM),
                isNew: isNewJob,
                companyId: Number(data === null || data === void 0 ? void 0 : data.companyId)
            };
            if ((data === null || data === void 0 ? void 0 : data.jobInvitation) && ((_c = data === null || data === void 0 ? void 0 : data.jobInvitation) === null || _c === void 0 ? void 0 : _c.jobInvitationId) > 0) {
                properties.invitationId = (_d = data === null || data === void 0 ? void 0 : data.jobInvitation) === null || _d === void 0 ? void 0 : _d.jobInvitationId;
            }
            tracking({
                eventName: 'js_search_result_page:search_job_impression',
                properties: __assign(__assign({}, trackingSetting === null || trackingSetting === void 0 ? void 0 : trackingSetting.additionalField), properties)
            });
            isAleadyTrackingViewJob.current = true;
        }
    }, [isElementOnScreen, isNewJob]);
    var renderMatchTooltipBadge = function (isHaveSeparator) {
        return (data === null || data === void 0 ? void 0 : data.isMatching) ? (React__default.createElement(React__default.Fragment, null,
            isHaveSeparator ? React__default.createElement(Separator, null) : null,
            React__default.createElement(StyledTooltip, { className: 'matched-job', tooltipClassName: 'matched-job-tooltip', custom: { maxWidth: '220px' }, content: React__default.createElement(MatchingText, null, t('This job is consistent with the following criteria in your profile: Title, Skills, Workplace, Category.')), referenceElement: React__default.createElement(BadgeTag, { type: 'Matching', langCode: langCode }) }))) : null;
    };
    var renderBadges = function () {
        if (forceNormalJob) {
            return null;
        }
        // Premium job can't detect by service code
        var badges = [];
        if (robot === null || robot === void 0 ? void 0 : robot.enable) {
            isUrgentJob = serviceCode.indexOf(SERVICE_CODE_URGENT_JOB) > -1;
            isTopManagementJob = serviceCode.indexOf(SERVICE_CODE_TOP_MANAGEMENT_JOB) > -1;
            isHeadhuntJob =
                serviceCode.indexOf(SERVICE_CODE_HEADHUNT_JOB) > -1 ||
                    serviceCode.indexOf(SERVICE_CODE_HEADHUNT_JOB_MOBILE) > -1;
        }
        if (isUrgentJob || data.isUrgentJobM) {
            badges.push(badgeSettings.urgent);
        }
        if (isPremium) {
            badges.push(badgeSettings.premium);
        }
        if (isHeadhuntJob) {
            badges.push(badgeSettings.headHunter);
        }
        if (isTopManagementJob) {
            badges.push(badgeSettings.topManagement);
        }
        if (badges.length === 0) {
            return renderMatchTooltipBadge(false);
        }
        return (React__default.createElement(Badge.Container, null,
            badges.map(function (badge) {
                if (badge.utm) {
                    return React__default.createElement(BadgeTag, { key: badge.name, type: badge.name, langCode: langCode, utm: badge.utm });
                }
                else {
                    return React__default.createElement(BadgeTag, { key: badge.name, type: badge.name, langCode: langCode });
                }
            }),
            renderMatchTooltipBadge(true)));
    };
    var renderAppliedTextAndSaveIcon = function () {
        var isApplied = data.isApplied;
        return isApplied ? (React__default.createElement(AppliedText, null,
            React__default.createElement(DoubleTickIcon, null),
            " ",
            t('Applied')) // applied Text
        ) : (React__default.createElement(SaveJobWrapper, { onClick: function (e) {
                e.stopPropagation();
                e.preventDefault();
                if (!isLogin) {
                    handleLogin();
                    return;
                }
                isSaved ? handleUnsavedJob() : handleSaveJob();
            }, isSaved: isSaved }, !isSaveLoading ? (isSaved ? (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(HeartFillIcon, { width: 20, color: colors.primary[40] }),
            ' ',
            isLayoutPrimary ? t('Saved job') : null)) : (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(Misc.UnFavoriteIcon, { width: 18, height: 18, color: colors.grey[20] }),
            ' ',
            isLayoutPrimary ? t('Save job') : null))) : (React__default.createElement(SaveLoadingIcon, { iconColor: colors.grey[20] }))));
    };
    var renderAISummary = function () {
        var _a;
        if (!data.summary || !shouldMakeJobPriority || !enableAISummary)
            return null;
        var summary = (_a = data.summary) !== null && _a !== void 0 ? _a : [];
        return (React__default.createElement(AISummary.Container, null,
            React__default.createElement(AISummary.Label, null,
                React__default.createElement(TwinkleLinearGradientIcon, null),
                React__default.createElement("span", null, t('AI summary'))),
            React__default.createElement("ul", null, summary === null || summary === void 0 ? void 0 : summary.map(function (item, idx) { return (React__default.createElement("li", { key: idx }, item)); }))));
    };
    var linkJobLangCode = langCode === ELanguage.EN ? 'en' : 'vi';
    if (isForceJobLinkVI) {
        linkJobLangCode = 'vi';
    }
    var jobUrl = generateJobUrl(data.jobId || 0, data.alias || '', linkJobLangCode, '', utm);
    var previewJobUrl = jobUrl;
    if (data.jobInvitation && data.jobInvitation.jobInvitationId > 0) {
        var prefixQueryParams = jobUrl.indexOf('?') > 0 ? '&' : '?';
        jobUrl += "".concat(prefixQueryParams, "utm_source=job_search_invitation&utm_campaign=").concat(data.jobInvitation.jobInvitationId);
        previewJobUrl += "".concat(prefixQueryParams, "utm_source=preview_invitation&utm_campaign=").concat(data.jobInvitation.jobInvitationId);
    }
    var renderTitle = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        var title = function () {
            return headingTagTitleJob === 'h3' ? (React__default.createElement("h3", null,
                React__default.createElement("a", { href: jobUrl, title: data.jobTitle, target: '_blank' },
                    isNewJob ? (React__default.createElement(NewBadgeWrapper, null,
                        React__default.createElement(BadgeTag, { type: 'New', langCode: langCode }))) : null,
                    data.jobTitle))) : (React__default.createElement(CustomH2, { isPriority: shouldMakeJobPriority },
                React__default.createElement("a", { href: jobUrl, title: data.jobTitle, target: '_blank' },
                    isNewJob ? (React__default.createElement(NewBadgeWrapper, null,
                        React__default.createElement(BadgeTag, { type: 'New', langCode: langCode }))) : null,
                    data.jobTitle)));
        };
        return previewJob.enable ? (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(PreviewJob, { content: {
                    jobId: (_a = data.jobId) !== null && _a !== void 0 ? _a : 0,
                    logo: (_b = data.companyLogo) !== null && _b !== void 0 ? _b : '',
                    title: (_c = data.jobTitle) !== null && _c !== void 0 ? _c : '',
                    salary: (_d = data.prettySalary) !== null && _d !== void 0 ? _d : '',
                    jobLevel: langCode === ELanguage.VI ? data.jobLevelVI : data.jobLevel,
                    address: (_e = data.address) !== null && _e !== void 0 ? _e : '',
                    jobDescription: (_f = data.jobDescription) !== null && _f !== void 0 ? _f : '',
                    jobRequirements: (_g = data.jobRequirement) !== null && _g !== void 0 ? _g : '',
                    link: previewJobUrl,
                    isSaved: isSaved,
                    isApplied: !!data.isApplied,
                    isBlackList: !!data.isBlackList,
                    redirectTo: data.redirectTo || '',
                    jobInvitation: (_h = data.jobInvitation) !== null && _h !== void 0 ? _h : { jobInvitationId: 0, status: 0 }
                }, api: {
                    disableSelfApi: true
                }, onSaveClick: function () { return (isSaved ? handleUnsavedJob() : handleSaveJob(true)); }, onApplyClick: function () { return setShowApplyPopup(true); }, langCode: langCode, isLogin: isLogin }, title()),
            React__default.createElement(ApplyJobs, { accessToken: (_j = api === null || api === void 0 ? void 0 : api.accessToken) !== null && _j !== void 0 ? _j : '', isOpen: isShowApplyPopup, langCode: langCode, user: userInfo, jobInfo: data, baseMsUrl: (_k = api.baseUrl) !== null && _k !== void 0 ? _k : '', baseUrl: (_l = previewJob === null || previewJob === void 0 ? void 0 : previewJob.baseUrl) !== null && _l !== void 0 ? _l : '', initData: props.initData, onClose: function () { return setShowApplyPopup(false); } }))) : (title());
    };
    var renderCompanyName = function () {
        if (companyUrl && !data.isAnonymous) {
            var companyUrlWithUtm = "".concat(companyUrl);
            if (companyUTM !== '') {
                companyUrlWithUtm += "?".concat(companyUTM);
            }
            return (React__default.createElement(React__default.Fragment, null,
                React__default.createElement("a", { href: companyUrlWithUtm, title: data.companyName, target: '_blank' }, data.companyName)));
        }
        return (React__default.createElement("span", { className: 'company-name', title: !data.isAnonymous
                ? data.companyName
                : t('Information of this employer is hidden for confidentiality purposes.') }, !data.isAnonymous ? data.companyName : "Vietnamworks' Client"));
    };
    var renderPostedJobDay = function () {
        var today = new Date();
        var postedDate = data.onlineOn || '';
        var priorityOrder = new Date(data.priorityOrder || '').getTime();
        if (['lasted', 'oldest'].includes(sorting)) {
            postedDate = data.approvedOn || '';
        }
        else if (priorityOrder > 0) {
            postedDate = data.priorityOrder || '';
        }
        var target = new Date(postedDate);
        var diffTime = today.getTime() - target.getTime();
        var diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
        var diffHours = Math.floor(diffTime / (1000 * 60 * 60)) || 1;
        if (diffDays >= 1) {
            // If difference is 1 day or more, return the difference in days
            return "".concat(diffDays, " ").concat(t('day')).concat(diffDays > 1 ? t('s') : '', " ").concat(t('ago'));
        }
        else {
            // If difference is less than 1 day, return the difference in hours
            return "".concat(diffHours, " ").concat(t('hour')).concat(diffHours > 1 ? t('s') : '', " ").concat(t('ago'));
        }
    };
    // Init next/image component
    var NextImageWrapper = nextImage !== null ? nextImage() : null;
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("a", { href: jobUrl, target: '_blank' },
            React__default.createElement(Container, { ref: jobCardRef, className: classSelector }, jobCardHeight.current > 0 && !isElementOnScreen && enableVisualized ? (React__default.createElement("div", { style: { width: '100%', height: jobCardHeight.current } })) : (React__default.createElement(Wrapper, { isPriorityJob: shouldMakeJobPriority && !forceNormalJob, layout: layout },
                shouldMakeJobPriority && !forceNormalJob && React__default.createElement(RibbonTag, null, "TOP"),
                React__default.createElement(TopContainer, null,
                    React__default.createElement(Left.Container, null,
                        React__default.createElement("a", { className: 'img_job_card', href: jobUrl, title: data.jobTitle, target: '_blank' }, nextImage !== null && NextImageWrapper !== null ? (React__default.createElement(NextImageContainer, null,
                            React__default.createElement("div", null,
                                React__default.createElement(NextImageWrapper, { src: showLogo ? data.companyLogo : DEFAULT_IMAGE, alt: data.jobTitle, layout: 'fill' })))) : (React__default.createElement(Left.Avatar, { src: showLogo ? data.companyLogo : DEFAULT_IMAGE, loading: 'lazy', alt: data.jobTitle }))),
                        isLayoutSecondary ? (React__default.createElement("div", null,
                            React__default.createElement(Right.Title, { isBoldAndRed: isBoldAndRed && forceNormalJob === false, isViewed: !!(isJobSearchPage && data.isViewed) }, renderTitle()),
                            React__default.createElement(CompanyName, null, renderCompanyName()))) : null),
                    React__default.createElement(Right.Container, null,
                        isLayoutPrimary ? (React__default.createElement(React__default.Fragment, null,
                            React__default.createElement(Right.Title, { isBoldAndRed: isBoldAndRed && forceNormalJob === false, isViewed: !!(isJobSearchPage && data.isViewed) }, renderTitle()),
                            React__default.createElement(CompanyName, null, renderCompanyName()))) : null,
                        renderBadges(),
                        React__default.createElement(Salary, null,
                            React__default.createElement(SalaryIcon, null),
                            data.prettySalary),
                        React__default.createElement(Location, null,
                            React__default.createElement(WorkingLocationIcon, null),
                            location),
                        renderAISummary())),
                React__default.createElement(BottomContainer, null,
                    React__default.createElement(Row, { gutter: [0, 8], align: 'middle' },
                        React__default.createElement(Col, { xs: 'auto' },
                            React__default.createElement(Badge.UpdatedTime, null, renderPostedJobDay())),
                        data.isViewed && (React__default.createElement(Col, { xs: 'auto' },
                            React__default.createElement(Badge.Viewed, null, t('Viewed')))),
                        React__default.createElement(Col, { xs: 'fill' }, data.jobInvitation &&
                            ((_a = data.jobInvitation) === null || _a === void 0 ? void 0 : _a.jobInvitationId) > 0 &&
                            data.jobInvitation.status === 0 ? (React__default.createElement(JobInvitationBlock, { title: t('Employer highly values your resume and has sent you an invitation to apply.') },
                            React__default.createElement(MailAddIcon, null),
                            React__default.createElement("p", null, t('Employer highly values your resume and has sent you an invitation to apply.')))) : null),
                        React__default.createElement(Col, { xs: 'auto' }, renderAppliedTextAndSaveIcon())))))))));
};

export { JobPostCard as default };
//# sourceMappingURL=index.js.map
